module.exports = __webpack_public_path__ + "assets/img/window.bf60da15.svg";